module.exports = __webpack_public_path__ + "static/1-ad27b4e088d3c7e0c0ef326a0d76f80b.png";